import React from 'react';
import Header from './Header';
import Footer from './Footer';
/* import ThemeToggle from './ThemeToggle'; */
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className='layout'>
      <Header />
      <main className='main-content'>{children}</main>
      <Footer />
      {/* <ThemeToggle /> */}
    </div>
  );
};

export default Layout;
